import {
  Card,
  CardContent,
  Checkbox,
  Grid,
  Typography,
} from "@material-ui/core";
import { BookingDay } from "./booking_day";
import { useEffect, useState } from "react";
import {
  BookingInfoPeriodDefinition,
  BookingInfoWeekDetailDto,
} from "../../../graphql/models/Booking";
import { DatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useDateTimeUtils } from "../../../hooks";
import { Alert } from "@material-ui/lab";

export interface BookingWeekProps {
  value: BookingInfoPeriodDefinition;
  onChange: (data: BookingInfoPeriodDefinition) => void;
}

export function BookingWeek(props: BookingWeekProps) {
  const { value } = props;
  const [weekItems, setWeekItems] = useState(value?.weekSlots);
  const [isClosed, setIsClosed] = useState(value.isClosed ?? false);
  const [isoDate, setIsoDate] = useState(value.fromDateInIso);
  const [showAllDays, setShowAllDays] = useState(true);

  const { datePickerValueToIsoDate, displayDate } = useDateTimeUtils();

  const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } =
    weekItems;

  const handleChangeDay = (key: string, data: BookingInfoWeekDetailDto) => {
    const newValue = { ...weekItems };
    newValue[key] = data;
    if (!showAllDays) {
      newValue.tuesday = { ...data };
      newValue.wednesday = { ...data };
      newValue.thursday = { ...data };
      newValue.friday = { ...data };
      newValue.saturday = { ...data };
      newValue.sunday = { ...data };
    }
    setWeekItems(newValue);
  };
  console.debug(`weekItems`, weekItems);

  const handleSetDate = (value: MaterialUiPickersDate) => {
    const v = datePickerValueToIsoDate(value);
    if (v) setIsoDate(v);
  };

  const handleSwitchCopy = (v: boolean) => {
    setShowAllDays(!v);
  };

  useEffect(() => {
    const newValue: BookingInfoPeriodDefinition = {
      isClosed,
      weekSlots: weekItems,
      fromDateInIso: isoDate,
    };
    props.onChange(newValue);
  }, [weekItems, isoDate, isClosed]);

  return (
    <Grid container spacing={2}>
      <Grid item md={4} lg={3}>
        <Card>
          <CardContent>
            <Typography variant={"h6"} align="center">
              Configurazione
            </Typography>
            <DatePicker
              label="A partire da"
              value={isoDate}
              inputVariant="outlined"
              onChange={handleSetDate}
              format="dd/MM/yyyy"
              style={{ width: "100%" }}
            />
            <Checkbox
              checked={isClosed}
              onChange={(e, checked) => setIsClosed(checked)}
            ></Checkbox>{" "}
            Periodo di chiusura
            {isClosed && (
              <Alert severity={"warning"}>
                Con questa impostazione, per tutte le date a partire dal{" "}
                {displayDate(isoDate)}, e fino al successivo periodo, il
                servizio NON sarà prenotabile
              </Alert>
            )}
          </CardContent>
        </Card>
      </Grid>
      {!isClosed && (
        <>
          <Grid item md={4} lg={3}>
            <BookingDay
              title="Lunedì"
              value={monday}
              showCopyCheck={true}
              onChange={(v) => handleChangeDay("monday", v)}
              switchCopyCheck={handleSwitchCopy}
            ></BookingDay>
          </Grid>
          {showAllDays && (
            <>
              <Grid item md={4} lg={3}>
                <BookingDay
                  title="Martedì"
                  value={tuesday}
                  onChange={(v) => handleChangeDay("tuesday", v)}
                ></BookingDay>
              </Grid>
              <Grid item md={4} lg={3}>
                <BookingDay
                  title="Mercoledì"
                  value={wednesday}
                  onChange={(v) => handleChangeDay("wednesday", v)}
                ></BookingDay>
              </Grid>
              <Grid item md={4} lg={3}>
                <BookingDay
                  title="Giovedì"
                  value={thursday}
                  onChange={(v) => handleChangeDay("thursday", v)}
                ></BookingDay>
              </Grid>
              <Grid item md={4} lg={3}>
                <BookingDay
                  title="Venerdì"
                  value={friday}
                  onChange={(v) => handleChangeDay("friday", v)}
                ></BookingDay>
              </Grid>
              <Grid item md={4} lg={3}>
                <BookingDay
                  title="Sabato"
                  value={saturday}
                  onChange={(v) => handleChangeDay("saturday", v)}
                ></BookingDay>
              </Grid>
              <Grid item md={4} lg={3}>
                <BookingDay
                  title="Domenica"
                  value={sunday}
                  onChange={(v) => handleChangeDay("sunday", v)}
                ></BookingDay>
              </Grid>
            </>
          )}
        </>
      )}
    </Grid>
  );
}
